"use client"

import { IterationCw } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `IterationCwIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const IterationCwIcon = component(Icon)({ as: IterationCw })
